import { AutostoreBin, Props as AutostoreBinProps } from "./AutostoreBin";
import { ActivityState, BinState } from "./BinState";
import { useBinAnimation } from "./useBinAnimation";

type Props = Omit<AutostoreBinProps, "state"> & {
  /** The port number listen to for animation updates */
  portId: number;
  /** Bypass the current bin state and specify your own */
  stateOverride?: ActivityState;
  /** The port side index for multiport-enabled ports. When only one side of the
   * multiport is used at time, this facilitates showing the other as inactive.
   */
  portSideIndex?: number;
};

export const AutostoreBinWithAnimation = ({
  portId,
  portSideIndex,
  stateOverride,
  ...rest
}: Props) => {
  const { animationCategory, activityState, binsAbove, selectedBin } =
    useBinAnimation(portId, portSideIndex);

  const getBinState = (): BinState => {
    if (stateOverride) {
      return stateOverride;
    }

    const baseState = animationCategory ?? activityState;

    // When the bin data from props has a different binId than what the port
    // reports, the port is still transitioning. Force "Waiting for Bin" to avoid
    // briefly flashing the wrong bin number.
    const isBinMismatch =
      !!rest.binId && selectedBin != null && rest.binId !== selectedBin;

    return isBinMismatch ? "Waiting for Bin" : baseState;
  };

  return <AutostoreBin {...rest} state={getBinState()} binsAbove={binsAbove} />;
};
